import {
  Sun, Battery, Wrench, Zap, Pickaxe, Map, Users, Factory,
} from "lucide-react";
import SEO from "@/components/SEO";
import ScopeRail from "@/components/ScopeRail";
import CTABanner from "@/components/CTABanner";
import ClientMarquee from "@/components/ClientMarquee";
import {
  HomeHero, TrustStrip, StatsBand, ServicesGrid,
  FeaturedProjects, AdvantageGrid, FleetTeaser,
} from "@/components/HomeSections";
import { projects } from "@/data/projects";

const SERVICES = [
  { icon: Sun, title: "Solar Plant I&C", blurb: "Module mounting structure erection, module installation, DC/AC works and full testing & commissioning for ground-mount and rooftop solar.", anchor: "#solar-ic" },
  { icon: Battery, title: "BESS Installation & Commissioning", blurb: "Installation, termination and commissioning support for battery energy storage systems and hybrid plants.", anchor: "#bess" },
  { icon: Wrench, title: "EPC / Balance of Plant", blurb: "End-to-end execution of civil, mechanical and electrical BoP packages for utility-scale and C&I projects.", anchor: "#epc" },
  { icon: Zap, title: "Electrical Contracting", blurb: "Licensed LT/HT electrical works, transformer installation, SVG installation, harmonic solutions and maintenance.", anchor: "#electrical" },
  { icon: Pickaxe, title: "Earth Work & Piling", blurb: "Land levelling, excavation, trenching and piling with our own DTH rig, hydraulic auger and JCB piling machines.", anchor: "#earthwork" },
  { icon: Map, title: "Land Liaison Services", blurb: "On-ground land identification, documentation and liaison support in Rajasthan's solar belt.", anchor: "#land" },
  { icon: Users, title: "Manpower & Material Supply", blurb: "Skilled electricians, fitters, riggers and supervisors with tools, consumables and site accommodation.", anchor: "#manpower" },
  { icon: Factory, title: "Industrial & Infrastructure Support", blurb: "Electrical and civil execution support for industrial and infrastructure projects.", anchor: "#industrial" },
];

const FEATURED_SLUGS = ["25mw-solar-park-barmer", "bess-installation-rajasthan", "piling-campaign-bikaner"];
const FEATURED = FEATURED_SLUGS.map((s) => projects.find((p) => p.slug === s));

export default function Home() {
  return (
    <>
      <SEO
        title="Yaduraj Enterprises | Solar & BESS I&C, EPC and Electrical Contractor — Rajasthan, India"
        description="Asset-backed installation & commissioning for solar and BESS projects. Owned piling rigs, JCBs and licensed electrical teams from Barmer, Rajasthan."
      />

      <HomeHero />
      <TrustStrip />
      <StatsBand />

      <section className="ye-section">
        <div className="ye-container" style={{ textAlign: "center" }}>
          <span className="ye-eyebrow">How We Execute</span>
          <h2 className="ye-display ye-h2" style={{ margin: "6px 0 0", maxWidth: 920, marginInline: "auto" }}>
            The Full Project Sequence, One Contractor
          </h2>
          <div style={{ marginTop: 18 }}>
            <ScopeRail />
          </div>
        </div>
      </section>

      <ServicesGrid services={SERVICES} />
      <FeaturedProjects featured={FEATURED} />

      <section className="ye-section ye-section--bg" style={{ paddingBottom: 70 }}>
        <div className="ye-container" style={{ textAlign: "center", marginBottom: 24 }}>
          <span className="ye-eyebrow">Trusted By</span>
          <h2 className="ye-display ye-h2" style={{ margin: "6px 0 0" }}>Companies We Work With</h2>
        </div>
        <ClientMarquee />
      </section>

      <AdvantageGrid />
      <FleetTeaser />
      <CTABanner />
    </>
  );
}
